module.exports = __webpack_public_path__ + "static/media/icon_metric-enable.ef71a366.svg";